import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Card, Loader, Input, Label, Message, Segment } from 'semantic-ui-react';
import { compose } from 'recompose';
import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';

import InfluencerTag from '../../components/influencer-tag';

const tagsContainerStyle = {
  minHeight: 50,
};

const errorStyle = {
  color: '#ef3a50',
  fontSize: 12,
  fontWeight: 'bold',
};

class TagsManager extends React.Component {
  //
  constructor() {
    super();
    this.state = {
      tags: [],
      newTagValue: '',
      isLoadingTags: true,
      tagsLoaded: false,
      isAddingTag: false,
    };
  }

  async componentDidMount() {
    await this.onLoadTags();
  }

  onInputChanged = (event, { value }) => {
    this.setState({
      newTagValue: value,
    });
  }

  onLoadTags = async () => {
    const { restClient, userInfo: { organisationId } } = this.props;
    this.setState({
      isLoadingTags: true,
    });
    const response = await restClient.get(`tags?filter[organisation]=${organisationId}`);
    const tags = _.get(response, 'data.data', []);
    this.setState({
      tags,
      isLoadingTags: false,
      tagsLoaded: true,
    });
  }

  onTagSelected = tagId => {
    this.setState({
      editedTagId: tagId,
    });
  }

  onAddNewTag = () => {
    const { restClient, userInfo: { name, organisationId } } = this.props;
    const { newTagValue } = this.state;
    this.setState({
      isAddingANewTag: true,
    }, async () => {
      const postData = {
        attributes: {
          value: newTagValue,
          createdBy: name,
          organisation: {
            type: 'organisations',
            id: organisationId,
          },
        },
      };
      await restClient.post('/tags', {
        data: postData,
      });
      this.setState({
        isAddingANewTag: false,
        isLoadingTags: true,
        newTagValue: '',
      }, this.onLoadTags);
    });
  }

  onDeleteTag = async tagId => {
    const { restClient } = this.props;
    await restClient.delete(`tags/${tagId}`);
    await this.onLoadTags();
  }

  onSaveTag = async (tagId, value) => {
    const { restClient } = this.props;
    await restClient.patch(`tags/${tagId}`, {
      data: {
        attributes: {
          value,
        },
      },
    });
    await this.onLoadTags();
  }

  render() {
    const { newTagValue, isAddingANewTag, isLoadingTags, tags, tagsLoaded } = this.state;
    const duplicateTagToBeAdded = _.some(tags, ['attributes.value', newTagValue]);
    const actionProps = {
      disabled: _.isEmpty(_.trim(newTagValue)) || duplicateTagToBeAdded,
      icon: 'plus',
      content: 'Add tag',
      loading: isAddingANewTag,
      onClick: this.onAddNewTag,
    };


    return (
      <Card fluid>
        <Card.Content>
          <h3>Tags Manager</h3>
        </Card.Content>
        <Card.Content>

          {
            isLoadingTags &&
            <Segment
              style={tagsContainerStyle}
              basic
            >
              <Loader active content="Loading new tags..." />
            </Segment>
          }
          {
            !isLoadingTags && (
              <Segment basic style={tagsContainerStyle}>
                {
                  tagsLoaded && _.isEmpty(tags) && <Message warning content="No tags created yet." />
                }
                <Label.Group>
                  {
                    _.map(tags, tag => <InfluencerTag
                      key={tag.id}
                      onClick={this.onTagSelected}
                      onSave={this.onSaveTag}
                      onDelete={this.onDeleteTag}
                      {...tag}
                    />)
                  }
                </Label.Group>
              </Segment>
            )
          }
        </Card.Content>
        <Card.Content>
          <Input
            fluid
            value={newTagValue}
            action={actionProps}
            onChange={this.onInputChanged}
            placeholder="Add a new tag"
          />
          {
            duplicateTagToBeAdded && <span style={errorStyle}>This tag already exists</span>
          }
        </Card.Content>
      </Card>
    );
  }
}

TagsManager.propTypes = {
  restClient: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
};

export default compose(
  hasRESTClient,
  hasUserInfo,
)(TagsManager);



/** WEBPACK FOOTER **
 ** ./src/containers/tags-manager/index.js
 **/